import store from "./../store/index";
import { webTracing } from '@gyasset/shared/utils';
import {getWebTracingUrl} from './base'

/**
 * 字符串判断 空
 */
export function isEmpty (val) {
  if (val === '' || val === null || val === undefined ){
     return true
  }
  return  false
}


//todo webSdk web-tracing 初始化
export const webTracingInit = async (userId) => {
  const {webTracingUrl, appCode} = await getWebTracingUrl()
  console.log(webTracingUrl, appCode, 'webTracingUrl, appCode=', userId)
  webTracing.init({
    requestUrl: webTracingUrl,
    appName: appCode,
    appCode: appCode,
    // performance: true,
    // pv: true,
    // error: true,
    // performanceFirstResource: true,
    // eventUnload: true,
    // eventCore: true,
    // event: true
  })
  if (userId) webTracing.setUserUuid(userId)
}

//todo webSdk web-tracing 更新登录用户名
export const webTracingSetUserUuid = (name) => {
  name = name || store.state.base.userId
  // console.log("设置webTracing  userName", name)
  webTracing.setUserUuid(JSON.stringify(name) || '')
}

//todo webSdk web-tracing 清除登录用户名
export const webTracingClearUserUuid = (name) => {
  // console.log("清除登录用户名webTracing  userName", name)
  webTracing.setUserUuid('')
}
